'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'bomb';
var width = 576;
var height = 512;
var aliases = [128163];
var unicode = 'f1e2';
var svgPathData = ['M64 304c0 97.2 78.8 176 176 176s176-78.8 176-176c0-21.9-4-42.8-11.3-62.1l-3.6-9.7 24.3-24.3-90-90c-15.1 13.4-23.9 21.3-26.6 23.7l-9-3.2C281.1 131.7 261 128 240 128 142.8 128 64 206.8 64 304zm48 0c0-70.7 57.3-128 128-128l16 0 0 32-16 0c-53 0-96 43-96 96l0 16-32 0 0-16z', 'M496-8l-32 0 0 56-56 0 0 32 56 0 0 56 32 0 0-56 56 0 0-32-56 0 0-56zM347.3 84.7L336.6 74c-5.4 4.8-17.1 15.2-35.1 31.2-19.5-6-40.1-9.2-61.5-9.2-114.9 0-208 93.1-208 208s93.1 208 208 208 208-93.1 208-208c0-22.1-3.5-43.5-9.9-63.5 15.8-15.8 26.6-26.6 32.5-32.5-2-2-20.6-20.7-56-56 8.7-8.7 16.7-16.7 24-24L416 105.4c-7.3 7.3-15.3 15.3-24 24L347.3 84.7zm-31.5 50.6l19.5-17.3 90 90-24.3 24.3 3.6 9.7c7.3 19.3 11.3 40.2 11.3 62.1 0 97.2-78.8 176-176 176S64 401.2 64 304 142.8 128 240 128c21 0 41.1 3.7 59.8 10.4l9 3.2 7.1-6.3zM144 304c0-53 43-96 96-96l16 0 0-32-16 0c-70.7 0-128 57.3-128 128l0 16 32 0 0-16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBomb = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;